module.exports = __webpack_public_path__ + "static/img/o1.20d8b3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/o1.jpg
// module id = rsHH
// module chunks = 0